export enum RequestVerificationCodeType {
  PASSWORD_OR_EMAIL_CHANGE = 'PASSWORD_OR_EMAIL_CHANGE',
  ACCESS_REQUEST_EMAIL_VERIFICATION = 'ACCESS_REQUEST_EMAIL_VERIFICATION',
}
